import {useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app";
import {postSubmit, isEmpty, scrollToComponent, stringToDate, formatDate, FORMAT_DATE_BACK} from "@ui-seeker/utils";

import { usePricingDiscountRoleConfig } from "Pages/Pricing/PriceDiscount/@hooks";
import {evolutionOffersDataFilters} from "../../../@signals"


export default function usePricingDiscountOffersEvolutionData() {
	const { showToast } = useAppToast()
	const { urlApi } = usePricingDiscountRoleConfig()

	const dataEvolution = useSignal({})
	const dataEvolutionKeys = useSignal({})
	const chartColor = useSignal({})
	const skuName = useSignal("")
    const dateRange = useSignal([])
	const isLoadingDataEvolution = useSignal(false)

    useEffect(() => {
		if (!isEmpty(evolutionOffersDataFilters.value)) batch(() => {
			isLoadingDataEvolution.value = true
            dataEvolution.value = {}
			showToast.promise(postSubmit(`${urlApi}/widgets-evolution`, evolutionOffersDataFilters.value).then(res => batch(() => {
                dataEvolution.value = res.chart
				dataEvolutionKeys.value = res.chartKeys
				chartColor.value = res.color
                dateRange.value = [stringToDate(evolutionOffersDataFilters.value.startDate), stringToDate(evolutionOffersDataFilters.value.endDate)]
                isLoadingDataEvolution.value = false
			})).catch(() => {
				isLoadingDataEvolution.value = false
				showToast.error()
			}
            ).finally(() => scrollToComponent('evolution-chart')))
		}) 

		if (isEmpty(evolutionOffersDataFilters.value)) batch( () => {
			dataEvolution.value = {}
			dataEvolutionKeys.value = {}
			skuName.value = ""
			chartColor.value = {}
		})

	}, [JSON.stringify(evolutionOffersDataFilters.value)]);

    const onChange = (e) => {
        batch(() => {
            dateRange.value = e
            evolutionOffersDataFilters.value = {
                ...evolutionOffersDataFilters.value,
                startDate: formatDate(e[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(e[1], { format: FORMAT_DATE_BACK }),
            }
        })
    }

    const resetEvolutionData = () => batch(() => {
		dataEvolution.value = {}
		dataEvolutionKeys.value = {}
		evolutionOffersDataFilters.value = {}
		chartColor.value = {}
	})

	return {
		dataEvolution: dataEvolution.value,
		isLoadingDataEvolution: isLoadingDataEvolution.value,
		dataEvolutionKeys: dataEvolutionKeys.value,
		chartColor: chartColor.value,
        dateRange: dateRange.value,

        onChange,
        resetEvolutionData
	}
}